import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { INVOICES_QUERY } from "./get-all";

export const useDeleteInvoice = () => {
  const [deleteMutation] = useMutation(DELETE_INVOICES_MUTATION, {
    refetchQueries: [INVOICES_QUERY],
    update(cache, { data }, { variables }) {
      if (!data?.deleteInvoices || !variables?.invoiceIds) return;

      cache.modify({
        fields: {
          invoices(existingInvoices, { readField }) {
            if (!existingInvoices?.invoices) return existingInvoices;

            const filteredInvoices = existingInvoices.invoices.filter(
              (invoiceRef: any) => {
                const invoiceDetailsId = readField(
                  "invoiceDetailsId",
                  invoiceRef,
                );
                return !variables.invoiceIds.includes(invoiceDetailsId);
              },
            );

            return {
              ...existingInvoices,
              invoices: filteredInvoices,
              pagination: {
                ...existingInvoices.pagination,
                totalItems: Math.max(
                  0,
                  existingInvoices.pagination.totalItems -
                    variables.invoiceIds.length,
                ),
              },
            };
          },
        },
      });
    },
    optimisticResponse: {
      deleteInvoices: {
        success: true,
      },
    },
  });

  const handleDeleteInvoices = useCallback(
    async (invoiceIds: string[]) => {
      await deleteMutation({
        variables: { invoiceIds },
      });
    },
    [deleteMutation],
  );

  return handleDeleteInvoices;
};

export const DELETE_INVOICES_MUTATION = gql`
  mutation DeleteInvoices($invoiceIds: [String!]!) {
    deleteInvoices(invoiceIds: $invoiceIds)
  }
`;
